var map = {
	"./Step1.svg": 1067,
	"./Step2.svg": 1068,
	"./Step3.svg": 1069,
	"./calendar_1week.svg": 1541,
	"./calendar_2weeks.svg": 1542,
	"./calendar_date.svg": 1543,
	"./calendar_hour.svg": 1544,
	"./calendar_month.svg": 1545,
	"./calendar_question.svg": 1546,
	"./continue_brief.svg": 1054,
	"./copy_brief.svg": 1053,
	"./new_brief.svg": 1055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1540;